import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useContent } from "../context/ContentContext";

export const Footer = () => {
  const { p } = useContent();
  const c = p("footer");
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      toast.success("Thank you — you're on the list.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    }
  };

  return (
    <footer className="bg-[#F0EFEA] border-t border-[#E4E1DB] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-display text-xl">{c.brand.name}</div>
          <p className="overline mt-1">{c.brand.tagline}</p>
          <p className="text-sm text-[#4A4947] mt-4 leading-relaxed max-w-xs">
            {c.brand.description}
          </p>
        </div>

        <div>
          <h4 className="overline mb-4">{c.explore.heading}</h4>
          <ul className="space-y-2 text-sm text-[#4A4947]">
            {(c.explore.links || []).map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-[#B35D4B]">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">{c.information.heading}</h4>
          <ul className="space-y-2 text-sm text-[#4A4947]">
            {(c.information.links || []).map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-[#B35D4B]">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">{c.newsletter.heading}</h4>
          <p className="text-sm text-[#4A4947] mb-3">{c.newsletter.body}</p>
          <form onSubmit={submit} className="flex" data-testid="newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={c.newsletter.placeholder} data-testid="newsletter-input"
              className="flex-1 min-w-0 bg-transparent border-b border-[#1C1B1A] py-2 text-sm outline-none placeholder:text-[#9a9793]" />
            <button type="submit" data-testid="newsletter-submit" className="ml-3 text-sm border-b border-[#1C1B1A] hover:text-[#B35D4B]">{c.newsletter.button_label}</button>
          </form>
          <div className="flex gap-4 mt-6">
            <a href={c.newsletter.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram className="w-5 h-5" strokeWidth={1.5} /></a>
            <a href={c.newsletter.facebook_url} target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook className="w-5 h-5" strokeWidth={1.5} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#E4E1DB]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-[#4A4947]">
          <span>© {new Date().getFullYear()} {c.bottom.copyright}</span>
          <Link to="/admin" className="hover:text-[#B35D4B]" data-testid="footer-admin-link">{c.bottom.admin_label}</Link>
        </div>
      </div>
    </footer>
  );
};
